import { z } from 'zod/v4';

export const assetLicenseAssignmentsResultSchema = z.object({
  ErrorCode: z.string().nullable(),
  TotalLicensesAssigned: z.number(),
  TotalLicensesUnAssigned: z.number(),
  TotalLicensesUpdated: z.number(),
  TotalLicensesNotProcessed: z.array(z.string()),
});

// Can't z.infer because of name changes
export type AssetLicenseAssignmentsResult = {
  errorCode: null | string;
  totalLicensesAssigned: number;
  totalLicensesNotProcessed: string[];
  totalLicensesUnAssigned: number;
  totalLicensesUpdated: number;
};
